import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import classNames from 'classnames';

import { useGetPromotionsQuery } from 'store/api/strapiService/promotionsController';

import { findPathPages } from 'utils/pages';
import { getDateFilters } from 'utils/promotions';

import ArrowCircleLink from 'components/UI/ArrowCircleLink/ArrowCircleLink';
import Loader from 'components/UI/Loader/Loader';
import Select from 'components/UI/Select/Select';
import NotFound from 'components/pages/NotFound/NotFound';
import Card from 'components/pages/Promotions/Card/Card';

import { PAGE_PATH } from 'components/config/pages';
import { CATEGORIES, MARKETS } from 'components/config/promotions';

import { ReactComponent as PromoIcon } from 'images/Icons/Promo.svg';

import styles from 'components/pages/Promotions/Category/Category.module.scss';
import stylesLayout from 'components/pages/Promotions/Promotions.module.scss';

const date = new Date();

const DEFAULT_MARKET = 'All';
const marketsOptions = [DEFAULT_MARKET, ...MARKETS];

export const Category = () => {
  const { provider, category } = useParams();

  const [market, setMarket] = useState(DEFAULT_MARKET);

  const { data, isLoading, isFetching } = useGetPromotionsQuery(
    {
      provider,
      dateFilters: getDateFilters(category, date),
      ...(market !== DEFAULT_MARKET && { market }),
    },
    {
      skip: !CATEGORIES[category],
    },
  );

  const { data: promotions, meta } = data ?? {};

  const handleChangeMarket = useCallback((_, value) => setMarket(value), []);

  if (isLoading) return <Loader />;

  if (!CATEGORIES[category] || !promotions) return <NotFound />;

  return (
    <div className={stylesLayout.wrapper}>
      <div className={styles.back}>
        <ArrowCircleLink
          path={findPathPages(PAGE_PATH.PROMOTIONS).replace(
            ':provider',
            provider,
          )}
          title="Go to all promotions"
          direction="left"
        />
      </div>
      <div className={stylesLayout.comingSoon}>
        <div className={stylesLayout.title}>
          <div>
            <span>{CATEGORIES[category].label}</span>
            <PromoIcon />
            <span>{meta?.pagination?.total}</span>
          </div>
          <div>
            <Select
              handleSelect={handleChangeMarket}
              title="Market"
              label="market"
              idElement={category}
              value={market}
              items={marketsOptions}
              width={205}
            />
          </div>
        </div>
        {!isFetching ? (
          <div className={classNames(stylesLayout.content, styles.content)}>
            {promotions.map((item) => (
              <Card
                key={item.documentId}
                item={item}
                category={category}
                provider={provider}
              />
            ))}
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default Category;
